import * as types from 'constants/templatesActionTypes';

const initialState = {
  loading: false,
  data: [],
  error: null,
  parameters: {
    loading: false,
    data: [],
    error: null
  },
  form: {
    loading: false,
    data: [],
    error: null
  }
};

export default (state = { ...initialState }, action = {}) => {
  switch (action.type) {
    case types.GET_LIST_TEMPLATES_LOADING: {
      return { ...state, loading: true, data: [] };
    }
    case types.GET_LIST_TEMPLATES_SUCCESS: {
      const { payload } = action;
      return { ...state, loading: false, data: payload, error: null };
    }
    case types.GET_LIST_TEMPLATES_FAILURE:
      return { ...state, loading: false, data: [], error: true };
    case types.GET_PARAMETERS_TEMPLATE_LOADING: {
      return {
        ...state,
        parameters: {
          loading: true,
          data: [],
          error: null
        }
      };
    }
    case types.GET_PARAMETERS_TEMPLATE_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        parameters: {
          loading: false,
          data: payload,
          error: null
        }
      };
    }
    case types.GET_PARAMETERS_TEMPLATE_FAILURE: {
      const { error } = action;
      return {
        ...state,
        parameters: {
          loading: false,
          data: error,
          error
        }
      };
    }
    case types.SAVE_PARAMETERS_TEMPLATE_LOADING: {
      return {
        ...state,
        form: {
          loading: true,
          data: [],
          error: null
        }
      };
    }
    case types.SAVE_PARAMETERS_TEMPLATE_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        form: {
          loading: false,
          data: payload,
          error: null
        }
      };
    }
    case types.SAVE_PARAMETERS_TEMPLATE_FAILURE: {
      const { error } = action;
      return {
        ...state,
        form: {
          loading: false,
          data: error,
          error
        }
      };
    }
    default:
      return state;
  }
};
